export var SymbolType;
(function (SymbolType) {
    SymbolType["PREVIOUS_PAGE"] = "PREVIOUS_PAGE";
    SymbolType["NEXT_PAGE"] = "NEXT_PAGE";
    SymbolType["ELLIPSIS"] = "ELLIPSIS";
})(SymbolType || (SymbolType = {}));
